export default "__VITE_ASSET__63183185__"